import type { ThemeJson } from '@apps/card/routes/CardCustomizer/CardCustomizer.types';

export const isValidStationeryDraft = (draft: { cardJSON: unknown }) => {
  const maybeConfig = draft.cardJSON as DeepPartial<ThemeJson>;
  return !!maybeConfig?.card?.front?.layers;
};
